const subservices = {
  // ── Mobilität ──
  'ppf-schutzfolien': {
    parent: 'Mobilität',
    parentHref: '/mobilitaet',
    title: 'PPF & Schutzfolien',
    subtitle: 'Unsichtbarer Schutz für Ihren Lack',
    description: 'Paint Protection Film (PPF) ist die effektivste Methode, den Originallack Ihres Fahrzeugs vor Steinschlägen, Kratzern und Umwelteinflüssen zu schützen. Wir verwenden ausschließlich selbstheilende Premium-Folien führender Hersteller.',
    features: [
      { title: 'Selbstheilende Oberfläche', desc: 'Feine Kratzer verschwinden durch Wärmeeinwirkung von selbst – der Lack bleibt makellos.' },
      { title: 'UV- & Korrosionsschutz', desc: 'Schutz vor Vergilbung, Vogelkot, Insektenrückständen und aggressiven Umwelteinflüssen.' },
      { title: 'Nahtlose Applikation', desc: 'Computergefertigter Zuschnitt und blasenfreie Montage für unsichtbare Ergebnisse.' },
      { title: 'Werterhalt', desc: 'Schützen Sie den Wiederverkaufswert Ihres Fahrzeugs durch makellose Lackoberflächen.' },
    ],
    applications: ['Motorhaube & Kotflügel', 'Stoßfänger & Schweller', 'Türkanten & Ladekanten', 'Komplettschutz Full-Body'],
  },
  'flottenbranding': {
    parent: 'Mobilität',
    parentHref: '/mobilitaet',
    title: 'Flottenbranding',
    subtitle: 'Ihre mobile Markenpräsenz',
    description: 'Ein einheitliches Flottendesign transformiert Ihre Fahrzeuge in rollende Werbeflächen. Wir entwickeln und applizieren CI-konforme Beklebungen für Flotten jeder Größe – vom Einzelfahrzeug bis zu Hunderten von Transportern.',
    features: [
      { title: 'CI-konforme Gestaltung', desc: 'Exakte Umsetzung Ihrer Corporate Identity auf jedem Fahrzeugtyp und -modell.' },
      { title: 'Skalierbare Produktion', desc: 'Effiziente Serienfertigung für Flotten von 5 bis 500+ Fahrzeugen.' },
      { title: 'Bundesweite Montage', desc: 'Unsere mobilen Teams folieren an Ihrem Standort – flexibel und termingerecht.' },
      { title: 'Flottenmanagement', desc: 'Dokumentation, Nachbestellungen und Ersatzteilservice für laufende Flotten.' },
    ],
    applications: ['Transporter & Sprinter', 'PKW-Flotten', 'LKW & Sattelzüge', 'Servicefahrzeuge'],
  },
  'teil-vollfolierung': {
    parent: 'Mobilität',
    parentHref: '/mobilitaet',
    title: 'Teil- & Vollfolierung',
    subtitle: 'Ihr Fahrzeug, Ihr Design',
    description: 'Ob dezentes Akzent-Design oder kompletter Farbwechsel: Unsere Folierungen verwandeln Ihr Fahrzeug nach Ihren Vorstellungen. Von Hochglanz bis Matt, von Metallic bis Satin – die Möglichkeiten sind grenzenlos.',
    features: [
      { title: 'Farbwechsel ohne Umlackierung', desc: 'Reversible Farbänderung mit Premium-Gussfolien – der Originallack bleibt geschützt.' },
      { title: 'Spezialeffekte', desc: 'Chrome Delete, Dachfolierung, Kontrastfolierungen und individuelle Akzente.' },
      { title: 'Motorsport-Erfahrung', desc: 'Design und Folierung für Rennfahrzeuge – belastbar, präzise und regelkonform.' },
      { title: 'Rückstandsfreie Entfernung', desc: 'Jede Folierung kann ohne Lackschäden professionell entfernt werden.' },
    ],
    applications: ['Vollfolierung (Color Change)', 'Teilfolierung & Akzente', 'Chrome Delete', 'Motorsport & Renndesign'],
  },
  'designentwicklung': {
    parent: 'Mobilität',
    parentHref: '/mobilitaet',
    title: 'Designentwicklung',
    subtitle: 'Vom Entwurf zur Realität',
    description: 'Jede herausragende Fahrzeuggestaltung beginnt mit einem durchdachten Konzept. Wir entwickeln Ihr Design am Bildschirm, visualisieren es fotorealistisch auf Ihrem Fahrzeug und optimieren es bis zur Produktionsreife.',
    features: [
      { title: '3D-Visualisierung', desc: 'Fotorealistische Darstellung Ihres Designs auf dem realen Fahrzeugmodell.' },
      { title: 'Iterativer Prozess', desc: 'Mehrere Entwurfsrunden mit Ihrem Feedback bis zum perfekten Ergebnis.' },
      { title: 'Druckdaten-Erstellung', desc: 'Produktionsfertige Daten mit korrekten Farbprofilen und Schnittmarken.' },
      { title: 'Markenintegration', desc: 'Nahtlose Einbindung Ihrer CI-Elemente in das Fahrzeugdesign.' },
    ],
    applications: ['Firmenfahrzeuge', 'Motorsport-Liveries', 'Promotion-Fahrzeuge', 'Privatfahrzeuge'],
  },

  // ── Raum & Architektur ──
  'architekturfolierung': {
    parent: 'Raum & Architektur',
    parentHref: '/architektur-raum',
    title: 'Architekturfolierung',
    subtitle: 'Fassaden und Oberflächen neu definiert',
    description: 'Architekturfolien ermöglichen die optische und funktionale Aufwertung von Gebäudefassaden, Aufzugskabinen, Treppenhäusern und Innenwänden – ohne aufwändige Baumaßnahmen und zu einem Bruchteil der Kosten.',
    features: [
      { title: 'Kosteneffizient', desc: 'Bruchteil der Kosten gegenüber Neuverkleidung oder Renovierung.' },
      { title: 'Schnelle Umsetzung', desc: 'Minimale Ausfallzeiten – Folierung oft in einem Tag möglich.' },
      { title: 'Vielfältige Optiken', desc: 'Holz, Stein, Beton, Metall – fotorealistisch und haptisch überzeugend.' },
      { title: 'Langlebig', desc: 'UV-stabile Folien mit 5–10 Jahren Haltbarkeit im Innen- und Außenbereich.' },
    ],
    applications: ['Fassadenverkleidung', 'Aufzugskabinen', 'Treppenhäuser', 'Empfangsbereiche'],
  },
  'sichtschutzfolien': {
    parent: 'Raum & Architektur',
    parentHref: '/architektur-raum',
    title: 'Glas- & Sichtschutzfolien',
    subtitle: 'Privatsphäre, Sonnenschutz und Gestaltung',
    description: 'Glasfolien bieten vielseitige Lösungen: von diskretem Sichtschutz über Sonnenschutz und Splitterschutz bis hin zu dekorativen Gestaltungsmöglichkeiten mit Firmenlogos oder Milchglas-Effekten.',
    features: [
      { title: 'Sichtschutz', desc: 'Diskrete Milchglasfolien für Büros, Praxen und Konferenzräume.' },
      { title: 'Sonnenschutz', desc: 'Reduzierung von Hitze und Blendung um bis zu 80% – ohne Verdunkelung.' },
      { title: 'Splitterschutz', desc: 'Sicherheitsfolien halten Glasscherben zusammen – Schutz für Mitarbeiter und Kunden.' },
      { title: 'Dekorative Gestaltung', desc: 'Firmenlogos, Muster und individuelle Designs auf Glas.' },
    ],
    applications: ['Bürotrennwände', 'Schaufenster', 'Konferenzräume', 'Eingangsbereiche'],
  },
  'interior-branding': {
    parent: 'Raum & Architektur',
    parentHref: '/architektur-raum',
    title: 'Interior Branding',
    subtitle: 'Marke im Raum erlebbar machen',
    description: 'Interior Branding verwandelt Ihre Geschäftsräume in eine Verlängerung Ihrer Markenidentität. Von der Empfangslobby bis zum Meetingraum – wir inszenieren Ihre Marke dreidimensional und erlebbar.',
    features: [
      { title: 'Wandgestaltung', desc: 'Großflächige Grafiken, Bildmotive und Markenwerte als visuelle Statements.' },
      { title: 'Leitsysteme', desc: 'CI-konforme Beschilderung und Orientierungssysteme.' },
      { title: 'Akustiklösungen', desc: 'Bedruckte Akustikpaneele – Marke und Raumkomfort vereint.' },
      { title: 'Möbelfolierung', desc: 'Bestehende Möbel optisch aufwerten statt ersetzen.' },
    ],
    applications: ['Empfang & Lobby', 'Meetingräume', 'Open-Space-Büros', 'Showrooms'],
  },
  'oberflaechen': {
    parent: 'Raum & Architektur',
    parentHref: '/architektur-raum',
    title: 'Oberflächenveredelung',
    subtitle: 'Materialoptik und Haptik perfektioniert',
    description: 'Durch hochwertige Spezialfolien verleihen wir bestehenden Oberflächen eine neue Optik und Haptik – ob Holzstruktur auf Metall, Betonoptik auf Spanplatten oder Marmor-Effekte auf Kunststoff.',
    features: [
      { title: 'Strukturfolien', desc: 'Echte 3D-Texturen die nicht nur optisch, sondern auch haptisch überzeugen.' },
      { title: 'Antimikrobielle Folien', desc: 'Hygienische Oberflächen für Gesundheitswesen und Gastronomie.' },
      { title: 'Brandschutz', desc: 'B1-zertifizierte Folien für öffentliche Gebäude und Gewerbeimmobilien.' },
      { title: 'Reinigungsfreundlich', desc: 'Pflegeleichte Oberflächen die Schmutz und Fingerabdrücke abweisen.' },
    ],
    applications: ['Theken & Empfangstresen', 'Aufzüge & Türen', 'Küchen & Nassräume', 'Ladenbau'],
  },
  'raumkonzepte': {
    parent: 'Raum & Architektur',
    parentHref: '/architektur-raum',
    title: 'Raumkonzepte',
    subtitle: 'Ganzheitliche Raumgestaltung aus einer Hand',
    description: 'Von der ersten Idee bis zur fertigen Umsetzung: Wir entwickeln umfassende Raumkonzepte die Architektur, Marke und Funktion in Einklang bringen – für Büros, Showrooms, Praxen und Retail-Flächen.',
    features: [
      { title: 'Bedarfsanalyse', desc: 'Erfassung Ihrer Anforderungen an Funktion, Ästhetik und Budget.' },
      { title: '3D-Raumplanung', desc: 'Visualisierung des fertigen Raums vor Baubeginn.' },
      { title: 'Materialberatung', desc: 'Auswahl passender Folien, Farben und Materialien für Ihr Projekt.' },
      { title: 'Umsetzung', desc: 'Koordination aller Gewerke für ein termingerechtes Ergebnis.' },
    ],
    applications: ['Büro-Neugestaltung', 'Retail & Ladenbau', 'Praxen & Kliniken', 'Gastronomie'],
  },

  // ── Markenkommunikation ──
  'grossformat': {
    parent: 'Markenkommunikation',
    parentHref: '/markenkommunikation',
    title: 'Großformatmedien',
    subtitle: 'Werbung die nicht übersehen wird',
    description: 'Großformatmedien bieten maximale Sichtbarkeit für Ihre Marke. Von Bannern über Planen bis zu textilen Drucken – wir produzieren und montieren großflächige Werbemedien für den Innen- und Außenbereich.',
    features: [
      { title: 'Digitaldruck XL', desc: 'Fotorealistische Drucke bis zu 5 Meter Breite auf diversen Medien.' },
      { title: 'Wetterfest', desc: 'UV- und witterungsbeständige Materialien für den Außeneinsatz.' },
      { title: 'Montageservice', desc: 'Professionelle Installation an Fassaden, Gerüsten und Trägersystemen.' },
      { title: 'Schnelle Lieferung', desc: 'Express-Produktion für zeitkritische Kampagnen und Events.' },
    ],
    applications: ['Fassadenbanner', 'Baustellenwerbung', 'Schaufenstergrafik', 'Bodenaufkleber'],
  },
  'werbesysteme': {
    parent: 'Markenkommunikation',
    parentHref: '/markenkommunikation',
    title: 'Werbesysteme',
    subtitle: 'Markante Präsenz am Standort',
    description: 'Werbesysteme wie Pylone, Leuchtkästen und Schilderanlagen geben Ihrem Standort Identität und Sichtbarkeit – bei Tag und Nacht. Wir planen, produzieren und montieren individuelle Lösungen.',
    features: [
      { title: 'Leuchtreklame', desc: 'LED-hinterleuchtete Systeme für maximale Fernwirkung.' },
      { title: 'Pylone & Stelen', desc: 'Freistehende Werbeträger in individuellen Formen und Größen.' },
      { title: 'Schilderanlagen', desc: 'Wegweiser- und Informationssysteme für Firmengelände.' },
      { title: 'Wartung & Service', desc: 'Regelmäßige Wartung und schneller Austausch bei Defekten.' },
    ],
    applications: ['Firmengebäude', 'Gewerbegebiete', 'Einkaufszentren', 'Parkplätze'],
  },
  'print': {
    parent: 'Markenkommunikation',
    parentHref: '/markenkommunikation',
    title: 'Printmedien',
    subtitle: 'Hochwertige Druckerzeugnisse',
    description: 'Trotz Digitalisierung bleiben Printmedien ein starkes Werkzeug der Markenkommunikation. Wir produzieren hochwertige Geschäftsdrucksachen, Broschüren und Kataloge, die Ihre Marke greifbar machen.',
    features: [
      { title: 'Offset & Digital', desc: 'Optimale Drucktechnik je nach Auflage und Anforderung.' },
      { title: 'Veredelung', desc: 'Prägung, Lack, Folienkaschierung – für haptische Premium-Erlebnisse.' },
      { title: 'Nachhaltigkeit', desc: 'Umweltfreundliche Papiere und Druckfarben auf Wunsch.' },
      { title: 'Logistik', desc: 'Lagerung, Konfektionierung und Versand an Ihre Standorte.' },
    ],
    applications: ['Visitenkarten', 'Imagebroschüren', 'Produktkataloge', 'Mailings'],
  },
  'messe-event': {
    parent: 'Markenkommunikation',
    parentHref: '/markenkommunikation',
    title: 'Event- & Messegrafik',
    subtitle: 'Wirkungsvolle Messeauftritte',
    description: 'Ein überzeugender Messeauftritt braucht professionelle Grafik. Wir produzieren und montieren sämtliche grafischen Elemente für Ihren Messestand – von der Rückwand bis zum Bodenbelag.',
    features: [
      { title: 'Standdesign', desc: 'Grafische Gestaltung und Produktion aller Standelemente.' },
      { title: 'Auf- & Abbau', desc: 'Unsere Teams montieren und demontieren direkt auf dem Messegelände.' },
      { title: 'Mobile Systeme', desc: 'Roll-Ups, Pop-Ups und faltbare Displays für flexible Einsätze.' },
      { title: 'Sonderlösungen', desc: 'Hängende Banner, Deckeninstallationen und 3D-Elemente.' },
    ],
    applications: ['Messestandgrafik', 'Eventdekoration', 'Konferenzen', 'Promotion-Aktionen'],
  },
  'pos': {
    parent: 'Markenkommunikation',
    parentHref: '/markenkommunikation',
    title: 'POS-Systeme',
    subtitle: 'Verkaufsförderung am Point of Sale',
    description: 'POS-Materialien lenken die Aufmerksamkeit am Verkaufsort und unterstützen die Kaufentscheidung. Wir entwickeln und produzieren maßgeschneiderte Displays und Systeme für den Einzelhandel.',
    features: [
      { title: 'Displaybau', desc: 'Individuelle Warenpräsentationen aus Acryl, Holz oder Metall.' },
      { title: 'Deckenhänger & Wobbler', desc: 'Aufmerksamkeitsstarke Elemente direkt am Regal.' },
      { title: 'Digitale Integration', desc: 'Kombination analoger Displays mit digitalen Screens.' },
      { title: 'Serienfertigung', desc: 'Wirtschaftliche Produktion auch in hohen Stückzahlen.' },
    ],
    applications: ['Thekendisplays', 'Bodendisplays', 'Regalmarkierung', 'Schaufenstergestaltung'],
  },
};

export default subservices;
